import { NO_DEVICES_VALUE } from '../transforms';

export const validateDeploymentInputs = (
  selectedDevice: string,
  modelComponentName?: string,
): { valid: boolean; errorMessage?: string } => {
  if (!selectedDevice || selectedDevice === NO_DEVICES_VALUE) {
    return {
      valid: false,
      errorMessage: 'Please select a valid device',
    };
  }

  if (!modelComponentName) {
    return {
      valid: false,
      errorMessage: 'Model component name not found in entity specification',
    };
  }

  return { valid: true };
};
